<template>
  <v-main class="pa-0" align-content="center">
    <div class="mx-5">Lidフォルダのフォルダを作成します。</div>
    <div class="mx-5">編集の際は、一度削除して再度作成してください。</div>
    <v-text-field
      color="#008CFF"
      clearable
      label="フォルダ名"
      hide-details
      v-model="folderName"
      class="mb-6"
    ></v-text-field>
    <v-divider></v-divider>
    <v-checkbox
      class="ma-0"
      v-for="item in mylid"
      :key="item.id"
      v-model="item.use"
      :label="`- ${item.title}`"
    ></v-checkbox>

    <v-btn
      tile
      width="200"
      elevation="0"
      color="#008CFF"
      class="white--text my-5"
      @click="makefolder()"
    >
      フォルダを作成
    </v-btn>
  </v-main>
</template>
    <script>
import firebase from "firebase/app";
import "firebase/firestore";
export default {
  data() {
    return {
      db: firebase.firestore(),
      numlid: 0,
      folderName: "",
      todayy: null,
      tagColors: ["#2B2B2B"],
      tagNames: ["フォルダー"],
    };
  },
  created() {
    this.numlid = this.lid.length;
    this.today();
  },
  computed: {
    lid() {
      return this.$store.state.lid;
    },
    navlid() {
      // ナビゲーター用
      // Lid - childlid +folder
      return this.$store.state.navlid;
    },
    uselid() {
      // フォルダに格納するLidたち
      let uselids = [];
      this.mylid.forEach(function (item) {
        if (item.use == true) {
          uselids.push(item.id);
        }
      });
      return uselids;
    },
    mylid() {
      // まだフォルダに属していないLid
      let availablelid = [];
      this.lid.forEach(function (item) {
        if (item.ischild != true) {
          availablelid.push(item);
        }
      });
      return availablelid;
    },
  },
  methods: {
    async makefolder() {
      console.log(this.uselid);
      await this.savelid();
      //submitLidでページリロードが入るので、savelidが終わっている必要がある
      this.submitLid();
    },
    onelidCandiAdmins(el) {
      this.candiAdm = el;
    },
    savelid: async function () {
      const self = this;
      this.uselid.forEach(function (item) {
        self.db
          .collection("0")
          .doc(item)
          .update(
            {
              ischild: true,
            },
            { merge: true }
          )
          .then(function (docRef) {})
          .catch(function (error) {
            console.error("Error Save ischild: ", error);
          });
      });
    },
    today() {
      // 日付をYYYY/MM/DD HH:DD:MI:SS形式で取得
      let date = new Date();
      let yyyy = date.getFullYear();
      let mm = this.toDoubleDigits(date.getMonth() + 1);
      let dd = this.toDoubleDigits(date.getDate());
      let hh = this.toDoubleDigits(date.getHours());
      let mi = this.toDoubleDigits(date.getMinutes());
      let se = this.toDoubleDigits(date.getSeconds());
      let ms = this.toDoubleDigits(date.getMilliseconds());
      this.todayy = yyyy + mm + dd + hh + mi + se + ms;
    },
    submitLid() {
      // フォルダーを作成する
      // 内部的には、単にLidを作成している
      this.today();
      let self = this;
      this.db
        .collection("0")
        .add({
          title: this.folderName,
          sort: this.todayy,
          createdAt: firebase.firestore.FieldValue.serverTimestamp(),
          updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
          config: false,
          isActive: true,
          isfolder: true, //フォルダ
          childrenid: this.uselid, //所属Lids
          isOpen: "public", //公開かどうか
          lidAdmin: [], //要検討
          ideaTheme: "フォルダー",
          ideaDesc: "フォルダー",
          counter: {
            member: 0,
            idea: 0,
            project: 0,
            activeUser: 0,
          },
          tags: {
            title: self.tagNames,
            color: self.tagColors,
          },
        })
        .then(function (docRef) {
          // 保存に成功した時はリロードをする
          self.folderName = "";
          self.$store.dispatch("getLid");
        })
        .catch(function (error) {
          // 保存に失敗した時
          console.error("Error adding document: ", error);
        });
    },
    toDoubleDigits(num) {
      num += "";
      if (num.length === 1) {
        num = "0" + num;
      }
      return num;
    },
  },
};
</script>
    